<template>
	<div>
		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"
						><h1>{{ getLabel('companyAddress', 'Practice Address') }}</h1></v-list-item-title
					>
					<v-list-item-subtitle class="text-center text-wrap">{{
						getLabel('companyAddressSectionDescription', 'Make it easy for a locum to find you, where are you located?')
					}}</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-container>
			<v-form ref="practiceAddressForm" v-model="valid" class="pa-4 pt-0">
				<v-card-text align="center" justify="center" class="justify-center text-center">
					<v-row
						><v-col> <v-text-field v-model="streetAddress" label="Street address" outlined :rules="streetAddressRules"></v-text-field> </v-col
					></v-row>

					<v-row
						><v-col> <v-text-field v-model="building" label="Building" hint="Office park, Building, Suite, etc…" persistent-hint outlined></v-text-field> </v-col
					></v-row>

					<v-row>
						<v-col><v-select v-model="provinceSelected" :rules="provinceRules" outlined :items="province_computed" persistent-hint label="Province"></v-select></v-col>
					</v-row>
					<v-row>
						<v-col
							><v-select
								v-model="provinceRegion"
								:rules="regionRules"
								outlined
								:items="region_computed"
								:disabled="provinceSelected ? false : true"
								persistent-hint
								:label="region"
								:hint="provinceSelected ? 'City/District/Region' : 'Please select a province.'"
							></v-select
						></v-col>
					</v-row>

					<v-row
						><v-col> <v-text-field v-model="postalCode" label="Postal code" :rules="postalCodeRules" outlined></v-text-field> </v-col
					></v-row>
				</v-card-text>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import { bus } from '@/main';
import axios from 'axios';
import store from '@/store';
import { provinceRegionPairs } from '@utils';

export default {
	data: () => ({
		valid: false,
		step: 'address-step',

		streetAddress: null,
		streetAddressRules: [v => !!v || 'Required'],

		building: null,
		buildingRules: [v => !!v || 'Required'],

		postalCode: null,
		postalCodeRules: [v => !!v || 'Required'],

		province: null,
		provinceSelected: null,
		province_region: null,
		province_regions: provinceRegionPairs,
		provinceRules: [v => !!v || 'Required'],

		provinceRegion: null,
		regionRules: [v => !!v || 'Required'],
	}),

	computed: {
		user() {
			return store.getters.user;
		},
		company() {
			return store.getters.company;
		},
		province_computed() {
			let result = [];
			this.province_regions.forEach(set => {
				if (!result.some(value => value == set.province)) {
					result.push(set.province);
				}
			});
			return result;
		},
		region_computed() {
			let result = [];
			if (this.provinceSelected) {
				this.province_regions.forEach(set => {
					if (this.provinceSelected == set.province) {
						result.push({ text: set.region, value: set });
					}
				});
			}
			return result;
		},
	},

	mounted() {
		window.scrollTo(0, 0);

		bus.$on('intent:submit-forms:address-step', data => {
			this.postToBackend(data);
		});

		this.$nextTick(() => {
			if (this.company.address) {
				this.streetAddress = this.company.address.street;
				this.building = this.company.address.building_name;
				this.postalCode = this.company.address.postal_code;
				this.provinceSelected = store.getters.company.address.province;
				this.region = store.getters.company.address.region;
				this.provinceRegion = {
					province: store.getters.company.address.province,
					region: store.getters.company.address.region,
				};
			}
		});
	},

	methods: {
		validate() {
			return this.$refs.practiceAddressForm.validate();
		},
		reset() {
			this.$refs.practiceAddressForm.reset();
		},
		resetValidation() {
			this.$refs.practiceAddressForm.resetValidation();
		},
		formatDate(date) {
			if (!date) return null;

			const [year, month, day] = date.split('-');
			if (day != undefined) {
				return `${month}/${day}/${year}`;
			} else {
				return `${month}/01/${year}`;
			}
		},
		parseDate(date, ignoreDay = false) {
			if (!date) return null;
			if (!ignoreDay) {
				const [month, day, year] = date.split('/');
				return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
			} else {
				const [month, day, year] = date.split('/');
				return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
			}
		},
		SubmitForm() {
			let valid = this.validate();
			if (valid) {
				bus.$emit('intent:submit-forms:' + this.name);
			}
		},
		checkStep() {
			const company = store.getters.company;
			const { address } = company;
			let fields = ['street', 'province', 'region', 'postal_code'];

			if (address && fields.every(key => address[key] && address[key].length > 0)) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},
		async postToBackend() {
			//post to api backend for this form.
			let valid = this.validate();

			if (valid) {
				bus.$emit('update:spinning', true);

				const token = store.getters.jwtToken;
				let body = {
					building_name: this.building,
					unit_no: 'N/A',
					street: this.streetAddress,
					suburb: store.getters.company.address.suburb,
					province: this.provinceRegion.province,
					region: this.provinceRegion.region,
					country: 'South Africa',
					postal_code: this.postalCode,
				};

				try {
					let response = await axios.put(store.getters.getAPI + '/companies/' + store.getters.company.id + '/address', body, { headers: { Authorization: token } });

					bus.$emit('form-submitted', { form: this.name, status: response.status });
					if (response.status === 200) {
						store.commit('SET_COMPANY', response.data.data); //refresh the users state. await it completed.
						bus.$emit('intent:next-step', 'address-step');
					}
				} catch (err) {
					console.error(err);
				} finally {
					bus.$emit('update:spinning', false);
				}
			}
		},

		beforeDestroy() {
			bus.$off('intent:submit-forms:address-step');
		},
	},
};
</script>
